<template>
  <boxwrap class="admin-list--inner" >
    <toolbar>
      <toolbar-items class="-searchbar">
        <select2
          class="toolbar-nav"
          v-model="selectedList"
        >
          <option2
            v-for="(statusItem, statusKey) of statusList"
            :key="statusKey"
            :value="statusItem.value"
            :name="statusItem.display"
            :selected="selectedList === statusItem.value"
          >
            {{ statusItem.display }}
          </option2>
        </select2>

        <search
          class="search-bar-wrap"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @refresh="search"
          @trigger="trigger"
          @clear="search"
        >
        </search>

        <button
          class="btn--create"
          title="생성"
          @click="showCreate=true; clearPartialAdmin()"
        >
          <i class="ico--create"></i>
        </button>

        <button
          @click="bulkEdit('setActive')"
          class="btn--restore"
          v-if="(selected.length > 0 && status !== 'active' && status !== 'deleted')"
        >
          <span>
            정상
          </span>
        </button>

        <button
          @click="bulkEdit('setInactive')"
          class="btn--delete"
          v-if="(selected.length > 0 && status !== 'inactive' && status !== 'deleted' )"
        >
          <span>삭제</span>
        </button>

        <button
          @click="bulkEdit('setRestore')"
          class="btn--restore"
          v-if="(selected.length > 0 && status === 'deleted')"
        >
          <i class="ico--restore"></i>
        </button>

        <button
          @click="bulkEdit('setDelete')"
          class="btn--delete"
          v-if="(selected.length > 0 && status !== 'deleted' && status !== 'active')"
        >
          <i class="ico--delete"></i>
        </button>

        <button
          class="btn--modify"
          title="저장"
          @click="bulkEdit('default')"
          v-if="selected.length > 0"
        >
          <i class="ico--save"></i>
        </button>

        <!-- div class="toolbar-rightbtns">
          <button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button>
        </div -->
      </toolbar-items>
    </toolbar>
    <boxwrap-contents :class="{'data-loading': showDataLoading}">
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>
      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
        v-else
      >
       <tbl-inner v-if="!isDataLoading">
          <tbl-head>
            <tbl-row>
              <tbl-td name="checkbox">
                <checkbox>
                  <input
                    type="checkbox"
                    @click="checkAll(admins)"
                    :checked="selectAll"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                name="no"
                :sort="true"
                v-if="checkCol('id', tblSetting)"
                @click.native="sort('id')"
              >
                번호
              </tbl-td>

              <tbl-td
                :sort="true"
                v-if="checkCol('created_at', tblSetting)"
                @click.native="sort('created_at')"
                name="created_at"
              >
                생성일자
              </tbl-td>

              <tbl-td
                :sort="true"
                v-if="checkCol('login_id', tblSetting)"
                @click.native="sort('login_id')"
                name="login_id"
              >
                아이디
              </tbl-td>

              <tbl-td
                :sort="true"
                v-if="checkCol('login_name', tblSetting)"
                @click.native="sort('login_name')"
                name="login_name"
              >
                닉네임
              </tbl-td>

              <tbl-td
                :sort="true"
                v-if="checkCol('level_id', tblSetting)"
                @click.native="sort('level_id')"
                name="level"
              >
                등급
              </tbl-td>

              <tbl-td
                :sort="true"
                v-if="checkCol('active', tblSetting)"
                @click.native="sort('active')"
                name="status"
              >
                상태
              </tbl-td>

              <tbl-td
                :sort="true"
                v-if="checkCol('last_login', tblSetting)"
                @click.native="sort('last_login')"
                name="last_login"
              >
                마지막 로그인
              </tbl-td>

              <tbl-td
                :sort="true"
                v-if="checkCol('last_login_ip', tblSetting)"
                @click.native="sort('last_login_ip')"
                name="last_login_ip"
              >
                로그인 아이피
              </tbl-td>

              <tbl-td
                :sort="true"
                @click.native="sort('updated_at')"
                name="updated_at"
              >
                수정일
              </tbl-td>

              <tbl-td
                :sort="true"
                v-if="checkCol('deleted_at', tblSetting)"
                @click.native="sort('deleted_at')"
                name="deleted_at"
              >
                삭제일
              </tbl-td>

              <tbl-td
                name="td-delete"
              >
              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row  v-for="admin in admins" :key="admin.id">
              <tbl-td name="checkbox">
                <checkbox>
                  <input
                    type="checkbox"
                    v-model="selected"
                    :value="admin.id"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                name="no"
              >
                {{admin.id}}
              </tbl-td>

              <tbl-td
                name="created_at"
              >
                {{ dateFormatter(admin.created_at) }}
              </tbl-td>

              <tbl-td
                name="login_id"
              >
                {{admin.login_id}}
              </tbl-td>

              <tbl-td
                name="login_name"
              >
                {{admin.login_name}}
              </tbl-td>

              <tbl-td name="level">
                <select2
                  v-model="admin.level_id"
                  @change.native="
                    setSelected(admin),
                    change({ value: admin.level_id, type: 'level', admin: admin.id, name: 'admin-page' })
                  "
                >
                  <option2
                    v-for="level in [levels[0]]"
                    :key="level.id"
                    :value="level.id"
                    :selected="admin.level_id === level.id"
                  >
                    {{ level.name }}
                  </option2>
                </select2>

                <!-- select
                  v-model="admin.level_id"
                  @change="setSelected(admin)"
                >
                  <option
                    v-for="level in levels"
                    :key="level.id"
                    :value="level.id"
                    :selected="admin.level_id === level.id"
                  >
                    {{ level.name }}
                  </option>
                </select -->
              </tbl-td>

              <tbl-td
                name="status"
              >
                <select2
                  ref="selectactive"
                  v-model="admin.active"
                  @change.native="
                    setSelected(admin),
                    change({ value: admin.active, type: 'status', admin: admin.id, name: 'admin-page' })
                  "
                >
                  <option2
                    value="true"
                    :selected="admin.active"
                  >
                    정상
                  </option2>

                  <option2
                    value="false"
                    :selected="!admin.active"
                  >
                    중지
                  </option2>
                </select2>
              </tbl-td>

              <tbl-td
                name="last_login"
              >
                {{ dateFormatter(admin.last_login) }}
              </tbl-td>

              <tbl-td
                name="last_login_ip"
              >
                {{ admin.last_login_ip || '-'}}
              </tbl-td>

              <tbl-td name="updated_at">
                {{ dateFormatter(admin.updated_at) }}
              </tbl-td>

              <tbl-td name="deleted_at">
                 {{ dateFormatter(admin.deleted_at) }}
              </tbl-td>

              <tbl-td name="td-delete">
                <button
                  @click="modify(admin)"
                  class="btn--default"
                  title="edit"
                >
                  <i class="ico--edit"></i>
                </button>

                <button @click="deleter(admin)"
                  :class="{'btn--delete':(!admin.deleted_at),'btn--restore':(admin.deleted_at)}"
                  title="restore/delete"
                >
                  <i :class="{'ico--delete':(!admin.deleted_at),'ico--restore':(admin.deleted_at)}"></i>
                </button>
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <pagination
            :total="count"
            v-model="params.page"
            :rows="params.rows"
            @page="trigger"
          >
          </pagination>
        </tbl-footer>
      </tbl>
    </boxwrap-contents>

      <modal
        class="modal--create-admin"
        title="관리자 생성"
        v-if="showCreate"
        :activate="showCreate"
        @activate="showCreate = $event"
      >
        <template slot="body">
          <div class="form-con">
            <div class="form-items">
              <div class="form-lbl">아이디</div>
              <div class="input-wrap">
                <input v-model="partialAdmin.login_id" placeholder="아이디" />
              </div>
            </div>
            <div class="form-items">
              <div class="form-lbl">닉네임</div>
              <div class="input-wrap">
                <input v-model="partialAdmin.login_name" placeholder="닉네임" />
              </div>
            </div>
            <div class="form-items">
              <div class="form-lbl">등급</div>
              <div class="input-wrap">
                <input v-model="partialAdmin.level_id" placeholder="등급" />
              </div>
            </div>
            <div class="form-items">
              <div class="form-lbl">비밀번호</div>
              <div class="input-wrap">
                <input v-model="partialAdmin.password" placeholder="비밀번호"/>
              </div>
            </div>
          </div>
        </template>

        <template slot="footer">
          <button
            class="btn--create -withlabel -right"
            @click="create()"
          >
            <i class="ico--create"></i>
            <span>생성</span>
          </button>
        </template>
      </modal>

      <modal
        class="modal--edit-admin"
        :title="'관리자 정보 수정'"
        v-if="showModify"
        :activate="showModify"
        @activate="showModify = $event"
      >
        <template slot="body">
          <div class="form-con">
            <div class="form-items">
              <div class="form-lbl">닉네임</div>
              <div class="input-wrap">
                <input
                  v-model="partialAdmin.login_name"
                  type="text"
                  placeholder="Login Name"
                  @input="change({ value: partialAdmin.login_name, type: 'login-name', admin: partialAdmin.id, name: 'admin-page' })"
                />
              </div>
            </div>
            <div class="form-items -disabled">
              <div class="form-lbl">아이디</div>
              <div class="input-wrap">
                <input disabled v-model="partialAdmin.login_id" type="text" placeholder="Login ID"/>
              </div>
            </div>
            <div class="form-items">
              <div class="form-lbl">등급</div>
              <div class="input-wrap">
                <select2
                  v-model="partialAdmin.level_id"
                  @change.native="change({ value: partialAdmin.level_id, type: 'level', admin: partialAdmin.id, name: 'admin-page' })"
                >
                  <option2
                    v-for="level in levels"
                    :key="level.id"
                    :value="level.id"
                    :selected="partialAdmin.level_id === level.id"
                  >
                    {{ level.name }}
                  </option2>
                </select2>

                <input
                  v-model="partialAdmin.level_id"
                  placeholder="Level"
                />
              </div>
            </div>
            <div class="form-items -disabled">
              <div class="form-lbl -disabled">
                현재 비밀번호
              </div>

              <div class="input-wrap">
                <input
                  disabled
                  v-model="showPassword"
                  type="text"
                  placeholder="현재 비밀번호"
                />
              </div>

              <div class="form-lbl">변경 비밀번호</div>
              <div class="input-wrap">
                <input
                  v-model="newPassword"
                  type="text"
                  placeholder="변경 비밀번호"
                  @input="change({ value: newPassword, type: 'password', admin: partialAdmin.id, name: 'admin-page' })"
                />
              </div>
            </div>
            <div class="form-items">
              <div class="form-lbl">사용유무:</div>
              <checkbox>
                <input v-model="partialAdmin.active"
                  type="checkbox"
                />
              </checkbox>
            </div>
          </div>
        </template>

        <template slot="footer">
          <button @click='saveModify(); showModify = false;'
            class="btn--modify -withlabel -right"
          >
            <i class="ico--save"></i>
            <span>수정</span>
          </button>
        </template>
      </modal>

      <!-- <table-settings
        :showTblSettings="showTblSettings"
        :allCols="allCols"
        :tblSetting="tblSetting"
        :activate="showTblSettings"
        v-if="modConfig.tableConfig"
        @activate="showTblSettings = $event"
        @load="showLoad()"
      >
      </table-settings> -->
  </boxwrap>
</template>
<script type="text/javascript">
// eslint-disable-next-line no-unused-vars
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

// components
import Checkbox from '@/components/base/Checkbox'
import Pagination from '@/components/base/Pagination'
import Modal from '@/components/base/Modal'
import Search from '@/components/base/search/Search'
import '@/components/base/select2/Select'
import CheckDataList from '@/components/base/CheckDataList'

// mixins
import { swal } from '@/assets/js/mixins/base/Swal'
import { checkAll } from '@/assets/js/mixins/base/CheckAll'
import { getListStatus } from '@/assets/js/mixins/common/GetListStatus'

// libs
import moment from 'moment'
import _groupBy from 'lodash/groupBy'
import _keys from 'lodash/keys'
import _get from 'lodash/get'
import _flattenDeep from 'lodash/flattenDeep'
import _filter from 'lodash/filter'
import _find from 'lodash/find'
import _map from 'lodash/map'

export default {
  name: 'AdminList',

  components: {
    Pagination,
    Modal,
    Search,
    Checkbox,
    CheckDataList
  },

  mixins: [
    getListStatus,
    swal,
    checkAll
  ],

  data () {
    let params = Object.assign(
      {
        rows: 50,
        page: 1,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      },
      this.$route.query
    )
    return {
      isDataLoading: true,
      keyGen: 0,
      selected: [],
      selectAll: false,
      newPassword: null,
      showDataLoading: false,
      params,
      isEmpty: false,
      showCreate: false,
      showModify: false,

      filterBy: [
        {
          value: 'login_id',
          display: '아이디'
        },
        {
          value: 'login_name',
          display: '닉네임'
        },
        {
          value: 'last_login_ip',
          display: '접속 IP'
        },
        {
          value: 'level_id',
          display: '레벨'
        }
      ],

      dateBy: [
        {
          value: '',
          display: '날짜 검색'
        },
        {
          value: 'created_at',
          display: '생성일자'
        },
        {
          value: 'updated_at',
          display: '수정일자'
        },
        {
          value: 'deleted_at',
          display: '삭제일자'
        }
      ],

      tblSetting: 'adminlist',

      allCols: [
        {
          display: 'no',
          value: 'no'
        },

        {
          display: 'created at',
          value: 'created_at'
        },
        {
          display: 'login id',
          value: 'login_id'
        },
        {
          display: 'login name',
          value: 'login_name'
        },
        {
          display: 'level',
          value: 'level'
        },
        {
          display: 'status',
          value: 'active'
        },
        {
          display: 'last_login',
          value: 'last_login'
        },
        {
          display: 'last_login_ip',
          value: 'last_login_ip'
        },
        /* {
          display: 'updated at',
          value: 'updated_at'
        }, */
        {
          display: 'deleted at',
          value: 'deleted_at'
        },
        {
          display: 'memo',
          value: 'memo'
        }
      ],

      statusList: [
        {
          value: 'all',
          display: '전체'
        },
        {
          value: 'active',
          display: '정상'
        },
        {
          value: 'inactive',
          display: '중지'
        },
        {
          value: 'deleted',
          display: '삭제'
        }
      ],

      handleModifiedList: []
    }
  },

  computed: {
    ...mapState('admin', ['admins', 'partialAdmin', 'count']),
    ...mapState('level', [ 'levels' ]),

    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    },

    showPassword () {
      if (this.partialAdmin.temp) {
        return window.atob(this.partialAdmin.temp)
      }
    }
  },

  watch: {
    async '$route' ($router) {
      this.search(this.generate($router.query))
    },

    async showModify () {
      if (!this.showModify) {
        this.search()
      }
    }
  },

  async created () {
    if (this.$route.params.status === undefined) {
      this.$router.push(`${this.$route.path}/`)
    }

    this.query = this.generate(this.query)
    this.search()
    this.getLevels()
  },

  methods: {
    ...mapActions('level', { getLevels: 'get' }),
    ...mapActions('admin-logs', { insertNewLogs: 'insertNewLogs' }),
    ...mapActions('admin', {
      setAdmins: 'fetchAdminList',
      createAdmin: 'createAdmin',
      setPartialAdmin: 'setPartialAdmin',
      editAdmin: 'editAdmin',
      deleteAdmin: 'deleteAdmin',
      clearPartialAdmin: 'clearPartialAdmin',
      bulkUpdate: 'bulkUpdate'
    }),

    trigger (query) {
      this.params = query || this.params
      this.$router.push({ query: this.params })
      // this.search()
    },

    setSelected (admin) {
      let f = _find(this.selected, s => s === admin.id)

      if (!f) { this.selected.push(admin.id) }
    },

    async search (query) {
      this.query = query || this.query
      this.status = this.$route.params.status
      let p = Object.assign(this.query, { stat: this.$route.params.status })

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }
      await this.setAdmins(p)
      // == flags set

      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.admins.length) {
        this.isEmpty = true
      }
    },

    async sort (arg) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = arg

      this.$router.push({ query: this.params })
    },

    async create () {
      if (!this.partialAdmin) return

      if (!this.partialAdmin.level_id || !this.partialAdmin.login_name || !this.partialAdmin.login_id || !this.partialAdmin.password) return

      const success = async () => {
        this.createAdmin(this.newPassword).then(async result => {
          if (result && result.status === 201 && !result.data.errors) {
            return this.$alert('success', '관리자를 성공적으로 등록 하였습니다.', {}, '', '관리자 등록 성공') // success for creating admin
          }

          if (result && result.data && result.data.msg === 'duplicate') {
            return this.$alert('error', 'Login ID already used', {}, '', 'Error')
          }

          await this.search()
          this.showCreate = false

          this.partialAdmin.level_id = null
          this.partialAdmin.login_name = null
          this.partialAdmin.login_id = null
          this.partialAdmin.password = null
          this.newPassword = null
        })
      }

      this.$alert('prompt', '관리자를 생성 하시겠습니까?', {}, { success }, '관리자 생성')
    },

    async modify (arg) {
      this.showModify = true
      this.newPassword = null
      this.setPartialAdmin(arg)
    },

    async bulkEdit (type) {
      let mappedAdmins = _map(this.selected, select => {
        return _find(this.admins, admin => admin.id === select)
      })

      let success = async () => {
        this.bulkUpdate({ type, data: mappedAdmins }).then(async r => {
          if (r) { this.$alert('success', '수정을 완료 하였습니다.', {}, '', '성공') }

          await this.search()
          this.$refs.selectactive.reset = true
          this.selected = []
        })

        if (type === 'default') {
          this.adminLogs(type)
        }
      }

      this.$alert('prompt', '정말 수정을 하시겠습니까?', {}, { success }, '관리자 수정')
    },

    async saveModify () {
      let success = async () => {
        let result = await this.editAdmin(this.newPassword)

        this.adminLogs('default')

        if (result.status === 204) {
          this.$alert('success', '수정을 완료 하였습니다.', {}, '', 'Success')
          await this.search()
        }
      }

      this.$alert('prompt', '정말 관리자 정보를 수정 하시겠습니까?', {}, { success }, '관리자 정보 수정')
    },

    async deleter (arg) {
      let success = async () => {
        let result = await this.deleteAdmin(arg)
        if (result.status === 202) {
          this.$alert('success', 'You have successfully deleted an admin.', {}, '', 'Success')
        }
      }

      this.$alert('prompt', '정말 관리자를 삭제 하시겠습니까?', {}, { success }, '관리자 삭제') // delete admin
    },

    dateFormatter (value) {
      if (!value) return '-'

      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },

    change (e) {
      const exist = this.handleModifiedList.findIndex(x => x.type === e.type && x.admin === e.admin)

      if (exist !== -1) {
        this.handleModifiedList[exist] = e
      } else {
        this.handleModifiedList.push(e)
      }
    },

    async adminLogs (action) {
      if (!this.handleModifiedList.length) return

      const join = e => e.join('/')

      const type = e => {
        if (e === 'default') return 'modify'
        if (e === 'setDelete') return 'delete'
        if (e === 'setActive') return 'active'
        if (e === 'setRestore') return 'restore'
        if (e === 'setInactive') return 'inactive'
      }

      const status = e => e ? 1 : 0
      const getUser = userID => _get(this.admins.find(e => e.id === parseInt(userID)), 'login_id')
      const level = levelID => _get(this.levels.find(e => e.id === parseInt(levelID)), 'name')

      let admins = _groupBy(this.handleModifiedList, 'admin')

      _keys(admins).forEach(e => {
        const result = admins[e].map(x => [
          x.type === 'level' ? join([x.type, level(x.value)].filter(Boolean)) : '',
          x.type === 'status' ? join([x.type, status(x.value)].filter(Boolean)) : '',
          ['password', 'login-name'].includes(x.type) ? join([x.type, x.value]) : ''
        ])

        const x = join(_filter(_flattenDeep(result), Boolean))

        admins[e] = join([getUser(e), x])
      })

      const params = _keys(admins).map(key => {
        return {
          action: type(action),
          memo: admins[key]
        }
      })

      await this.insertNewLogs(params)
      this.handleModifiedList = []
    }
  }
}
</script>
